import { Col, Container, Row } from 'react-bootstrap';
import { Link as ScrollTo } from 'react-scroll';

const AddressSection = () => {
  return (
    <Container className='py-[65px] lg:py-[45px] md:py-[37px] sm:py-[25px]'>
      <Row className='items-center'>
        <Col className='col-12 col-lg-8 col-md-4 sm:mb-[30px]'>
          <h5 className='font-serif w-[70%] text-tprimary font-medium mb-0 lg:w-[65%] md:w-[95%] xs:w-full'>
            How can we help you today?
          </h5>
        </Col>
        <Col className='col-12 col-lg-4 col-md-8'>
          <Row>
            <Col className='col-12 xs:mb-[30px]'>
              <span className='font-serif block text-tprimary font-medium mb-[10px]'>
                info@interlinkedoceana.com
              </span>
              <p className='w-[80%] mb-[5px] lg:w-[90%]'>
                South Island Place, 6 Wong Chuk Hang Rd, Wong Chuk
                Hang, Hong Kong
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default AddressSection;
